<template>
    <modal
        name="maternity-leave-form"
        class="modal--translation"
        v-cloak height="auto"
        :scrollable="true"
        :adaptive="true"
        :pivot-y="0.25"
        @before-open="beforeOpen"
    >
        <h5 class="modal-title my-1">{{ title }}</h5>

        <button @click="closeModal()" type="button" class="close close-modal">
            <i class="fal fa-fw fa-times"></i>
        </button>

        <maternity-leave-form
            :action="action"
            :data="maternityLeave"
            :trans="trans"
            :employee-id="employeeId"
            :maternity-leaves-types="maternityLeavesTypes"
            inline-template
        >
            <form class="form-horizontal form-create"
                  method="post"
                  @submit.prevent="onSubmit"
                  :action="this.action"
                  novalidate
            >
                <div class="card-block">
                    <h5>
                        {{ this.title }}
                    </h5>

                    <div class="form-group row align-items-center">
                        <label for="type" class="col-12 col-form-label">
                            {{ trans.columns.type }}
                        </label>
                        <div class="col-12">
                            <select id="type"
                                    v-model="form.type"
                                    class="custom-select w-100"
                            >
                                <option v-for="type in maternityLeavesTypes"
                                        :value="type.key"
                                >
                                    {{ type.label }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group row align-items-center"
                         :class="{
                            'has-danger': errors.has('date_start'),
                            'has-success': this.fields.date_start && this.fields.date_start.valid
                        }"
                    >
                        <label for="date_start" class="col-12 col-form-label">
                            {{ trans.columns.date_start }}
                        </label>

                        <div class="col-12">
                            <div class="input-group input-group--custom">
                                <div class="input-group-addon">
                                    <i class="fa fa-calendar"></i>
                                </div>

                                <datetime
                                    v-model="form.date_start"
                                    :config="datePickerConfig"
                                    vv-validate="'required|date_format:YYYY-MM-DD 00:00:00'"
                                    class="flatpickr"
                                    :class="{
                                        'form-control-danger': errors.has('date_start'),
                                        'form-control-success': this.fields.date_start && this.fields.date_start.valid
                                    }"
                                    :data-vv-as="trans.columns.date_start"
                                    id="date_start"
                                    name="date_start"
                                    :placeholder="trans.select_a_date">
                                </datetime>
                            </div>
                            <div v-if="errors.has('date_start')"
                                 class="form-control-feedback form-text"
                                 v-cloak
                            >
                                {{ errors.first('date_start') }}
                            </div>
                        </div>
                    </div>
                    <div class="form-group row align-items-center"
                         :class="{
                            'has-danger': errors.has('date_end'),
                            'has-success': this.fields.date_end && this.fields.date_end.valid
                        }"
                    >
                        <label for="date_end" class="col-12 col-form-label">
                            {{ trans.columns.date_end }}
                        </label>

                        <div class="col-12">
                            <div class="input-group input-group--custom">
                                <div class="input-group-addon">
                                    <i class="fa fa-calendar"></i>
                                </div>
                                <datetime
                                    v-model="form.date_end"
                                    :config="datePickerConfig"
                                    vv-validate="'date_format:YYYY-MM-DD 00:00:00'"
                                    :data-vv-as="trans.columns.date_end"
                                    class="flatpickr"
                                    :class="{
                                        'form-control-danger': errors.has('date_end'),
                                        'form-control-success': this.fields.date_end && this.fields.date_end.valid
                                    }"
                                    id="date_end"
                                    name="date_end"
                                    :placeholder="trans.select_a_date">
                                </datetime>
                            </div>
                            <div v-if="errors.has('date_end')"
                                 class="form-control-feedback form-text"
                                 v-cloak
                            >
                                {{ errors.first('date_end') }}
                            </div>
                        </div>
                    </div>

                    <input type="hidden" v-model="form.type">
                </div>

                <div class="card-footer text-center pb-0 pt-3">
                    <button type="submit" class="btn btn-primary" :disabled="submiting">
                        <i class="fa" :class="submiting ? 'fa-spinner' : 'fa-save'"></i>
                       {{ trans.actions.save }}
                    </button>
                </div>
            </form>
        </maternity-leave-form>
    </modal>
</template>


<script>
    import { Slovak as DatePickerLocaleSk } from "flatpickr/dist/l10n/sk.js";
    import { Czech as DatePickerLocaleCs } from "flatpickr/dist/l10n/cs.js";
    const userLanguage = document.documentElement.lang;

    export default {
        name: 'maternity-leave-modal-form',
        data: function() {
            return {
                action: this.baseUrl,
                type: 1,
                maternityLeave: null,
                url: null,
                title: '',

                maternityLeaveId: null,
                defaultFormData: {},
                datePickerConfig: {
                    dateFormat: 'Y-m-d',
                    altInput: true,
                    altFormat: 'd.m.Y',
                    locale: this.getDatePickerLocale(userLanguage)
                },
            }
        },

        props: {
            'baseUrl': {
                type: String
            },
            'trans': {
                type: Object
            },
            'maternityLeavesTypes': {
                type: Array,
            },
            'employeeId': {
                type: Number,
            },
        },

        methods: {
            beforeOpen (event) {
                this.maternityLeave = null;

                if(typeof event.params !== 'undefined') {
                    this.maternityLeave = event.params.maternityLeave;
                }

                if (this.maternityLeave !== null) {
                    this.title = this.trans.actions.edit;
                    this.action = this.maternityLeave.resource_url;
                } else {
                    this.title = this.trans.actions.create;
                    this.action = this.baseUrl;
                }
            },

            closeModal() {
                this.$root.$emit('updatematernityleavesgrid');
                this.$modal.hide('maternity-leave-form');
            },

            getDatePickerLocale(langCode) {
                if(langCode === 'sk') return DatePickerLocaleSk;
                if(langCode === 'cs') return DatePickerLocaleCs;

                return null;
            }
        },
    };
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/maternity-leave/modals/MaternityLeaveModalForm.vue